"use client";
import {NeoError} from "@/components/shared";
import {Spinner} from "@nextui-org/react";
import {GoogleMap, useJsApiLoader} from "@react-google-maps/api";
import {useRef, useState} from "react";
import {RoutesLeftBar} from "./leftSidebar";
import {RoutesRightBar} from "./rightSidebar";
export const RoutesPlanMap = function () {
  const mapKey: string = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || "";
  const mapRef = useRef<google.maps.Map | null>(null);

  const {isLoaded, loadError} = useJsApiLoader({
    googleMapsApiKey: mapKey
  });
  const containerStyle = {
    width: "100%",
    height: "500px"
  };
  const mapStyles = [
    {
      featureType: "all",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#7c93a3"
        },
        {
          lightness: "-10"
        }
      ]
    },
    {
      featureType: "administrative.country",
      elementType: "geometry",
      stylers: [
        {
          visibility: "on"
        }
      ]
    },
    {
      featureType: "administrative.country",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#c2d1d6"
        }
      ]
    },
    {
      featureType: "landscape",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#dde3e3"
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#c2d1d6"
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#a9b4b8"
        },
        {
          lightness: "0"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#a3c7df"
        }
      ]
    }
  ];
  const [map, setMap] = useState<google.maps.Map | null>(null);
  const [mapZoom, setMapZoom] = useState<number>(16);

  const [mapCenter, setMapCenter] = useState({
    lat: 11.0168,
    lng: 76.9558
  });
  const onMapLoad = (map: google.maps.Map) => {
    mapRef.current = map;
    setMap(map);
  };

  return (
    <div className="flex min-h-[calc(100vh-63px)] w-full">
      <div className="relative h-[calc(100vh-123px)] w-full">
        {/* Google Map */}
        {isLoaded ? (
          <GoogleMap
            mapContainerStyle={{width: "100%", height: "100%"}}
            center={mapCenter}
            zoom={mapZoom}
            onLoad={onMapLoad}
            options={{
              styles: mapStyles,
              disableDefaultUI: true, // Disable all default controls
              zoomControl: true, // Optional
              mapTypeControl: true,
              mapTypeControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_LEFT, // move satellite control
                style: google.maps.MapTypeControlStyle.DEFAULT
              },
              fullscreenControl: true,
              fullscreenControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_RIGHT // move fullscreen button
              }
            }}
          />
        ) : loadError ? (
          <NeoError message={loadError.message} />
        ) : (
          <div className="flex h-full w-full items-center justify-center">
            <Spinner />
          </div>
        )}

        {/* Left Sidebar */}
        <RoutesLeftBar />

        {/* Right Sidebar */}
        <RoutesRightBar />
      </div>
    </div>
  );
};
